<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formattedDate"
        @blur="handleInput"
        @keypress.enter="handleInput"
        persistent-hint
        outlined
        clearable
        v-bind="attrs"
        v-on="on"
        :required="required"
      >
        <template #label>
          {{ label }}
          <span v-if="required" class="red--text"><strong>*</strong></span>
        </template>
      </v-text-field>
    </template>
    <v-date-picker v-model="internalDate" @input="menu = false"></v-date-picker>
  </v-menu>
</template>

<script>
  import swh from '../assets/js/sw_helper'

  export default {
    props: {
      value: {
        type: String,
        default: new Date().toISOString().substring(0, 10),
      },
      label: {
        type: String,
        default: 'Select Date',
      },
      required: {
        type: Boolean,
        default: false,
      },
      format: {
        type: String,
        default: 'DD.MM.YYYY',
      },
    },
    data() {
      return {
        internalDate: this.value,
        menu: false,
      }
    },
    created() {
      // Normalize the initial value to the configured format so the parent's
      // v-model respects the format on load, not only after the date changes.
      if (this.internalDate && this.value !== this.formatDate(this.internalDate)) {
        this.$emit('input', this.formatDate(this.internalDate))
      }
    },
    computed: {
      formattedDate() {
        return this.formatDate(this.internalDate)
      },
    },
    methods: {
      formatDate(date) {
        return swh.formatDate(date, this.format)
      },
      parseDate(dateString) {
        return dateString.includes('.') ? swh.parseDate(dateString) : dateString
      },
      handleInput(e) {
        console.log('handle INput', e.target.value)
        this.internalDate = this.parseDate(e.target.value)
      },
    },
    watch: {
      internalDate(newVal) {
        this.$emit('input', this.formatDate(newVal)) // Emitting input event for v-model on parent
      },
      value(newVal) {
        if (newVal !== this.formatDate(this.internalDate)) {
          this.internalDate = this.parseDate(newVal)
        }
      },
    },
  }
</script>
